import { Guid } from "guid-typescript";

import { DataFieldValue } from "lib/data/model";

export class UniField {

	public readonly name: string = Guid.create().toString();
	public value: DataFieldValue;

	constructor(newValue: DataFieldValue) {

		this.value = newValue;
	}
}
